/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import moment from 'moment-timezone';

import RenderIf from '@components/global/RenderIf';
import { currency, pdfSafeValue } from '@global/helpers';
import Footer from './Footer.web';
import { PAGE_SIZE } from './constant';
import Header from './Header.web';

const PdfOrder = ({ data }) => {
  const isSpreading = data.type == 'spreading';
  const isVn = (data.is_active_for || []).includes('b2b_vn');

  const convertAddress = (value) => {
    if (value) {
      const result = [];
      if (value?.street) {
        result.push(value.street);
      }
      if (value?.district?.name) {
        result.push(value.district.name);
      }
      if (value?.city?.name) {
        result.push(value.city.name);
      }
      if (value?.province?.name) {
        result.push(value.province.name);
      }
      if (value?.postal_code) {
        result.push(value.postal_code);
      }
      if (result?.length) {
        return result.join(', ');
      }
    }

    return '-';
  };

  const customerPaymentTerms = data.customer?.payment_terms?.name || '-';
  const paymentTerms = data?.cash_before_delivery?.percentage
    ? 'Cash Before Delivery (CBD)'
    : typeof customerPaymentTerms === 'string'
    ? customerPaymentTerms.replace(/_/, ' ')
    : customerPaymentTerms;

  return (
    <Document>
      <Page size={PAGE_SIZE} style={styles.page} wrap>
        <Header isSpreading={isSpreading} isVn={isVn} />

        <View style={styles.container}>
          <View style={styles.headerSection}>
            <View style={styles.headerSubsection(isSpreading)}>
              <RenderIf condition={isSpreading}>
                <Text style={{ fontWeight: 700 }}>Notes:</Text>
                <Text>{pdfSafeValue(data.notes)}</Text>
              </RenderIf>
              <RenderIf condition={!isSpreading}>
                <Text style={{ fontWeight: 700 }}>Invoice Address:</Text>
                <Text>{pdfSafeValue(data.invoice_address?.name)}</Text>
                <Text>Inv</Text>
                <Text>{convertAddress(data.invoice_address)}</Text>
                <Text>
                  {data.invoice_address?.country?.name || 'Indonesia'}
                </Text>

                <Text style={{ fontWeight: 700 }}>Delivery Address:</Text>
                <Text>{pdfSafeValue(data.delivery_address?.name)}</Text>
                <Text>Delivery</Text>
                <Text>{convertAddress(data.delivery_address)}</Text>
                <Text>
                  {data.delivery_address?.country?.name || 'Indonesia'}
                </Text>
              </RenderIf>
            </View>
            <View style={styles.headerSubsection}>
              <Text>Order # {pdfSafeValue(data.reference_code)}</Text>
              <Text style={{ fontWeight: 700 }}>Your Reference:</Text>
              <Text>{pdfSafeValue(data.customer_po_number)}</Text>
              <View style={{ flexDirection: 'row' }}>
                <View style={{ marginRight: 10 }}>
                  <Text style={{ fontWeight: 700 }}>Date Ordered:</Text>
                  <Text>
                    {moment(data.order_date).format('DD/MMM/YYYY HH:mm:ss')}
                  </Text>
                </View>
                <View>
                  <Text style={{ fontWeight: 700 }}>Payment Terms:</Text>
                  <Text>{pdfSafeValue(paymentTerms)}</Text>
                </View>
              </View>
            </View>
          </View>

          <View style={styles.contentWrapper}>
            <View style={styles.tableHeader} fixed>
              <Text style={{ width: '49%' }}>Description</Text>
              <Text style={{ width: '10%' }}>Quantity</Text>
              <Text style={{ width: '10%' }}>Unit Price</Text>
              <Text style={{ width: '7%' }}>Disc.%</Text>
              <Text style={{ width: '7%' }}>Disc 2.%</Text>
              <Text style={{ width: '7%' }}>Taxes</Text>
              <Text style={{ width: '10%' }}>Amount</Text>
            </View>

            {(data.products || []).map((p, i) => (
              <View key={i} style={styles.tableRow}>
                <Text style={{ width: '49%', paddingRight: 10 }}>{p.name}</Text>
                <Text style={{ width: '10%' }}>{p.quantity}</Text>
                <Text style={{ width: '10%' }}>{p.unit_price}</Text>
                <Text style={{ width: '7%' }}>{p.discount_1}</Text>
                <Text style={{ width: '7%' }}>{p.discount_2}</Text>
                <Text style={{ width: '7%' }}>{p.taxes}</Text>
                <Text style={{ width: '10%' }}>{p.amount}</Text>
              </View>
            ))}
            <View style={{ flexDirection: 'row' }} wrap={false}>
              <View style={{ width: '76%', paddingRight: 10 }}>
                <RenderIf
                  condition={!isSpreading && (data.products || []).length > 0}>
                  <View style={{ paddingTop: 10, marginBottom: 16 }}>
                    <Text style={{ fontWeight: 700, fontSize: 8 }}>
                      Payment Method:
                    </Text>
                    <View>
                      <Text style={{ maxWidth: '100%', fontSize: 8 }}>
                        {pdfSafeValue(data?.sales_team?.payment_method)}
                      </Text>
                    </View>
                  </View>
                </RenderIf>
              </View>
              <View style={{ width: '24%' }}>
                <View style={[styles.tableRowSummary, { width: '100%' }]}>
                  <Text style={{ fontWeight: 700, width: '58%' }}>
                    Total without taxes
                  </Text>
                  <Text>{currency(data.subtotal, true)}</Text>
                </View>
                <View style={[styles.tableRowSummary, { width: '100%' }]}>
                  <Text style={{ width: '58%' }}>VAT</Text>
                  <Text>{currency(data.total_tax_amount, true)}</Text>
                </View>
                <View style={[styles.tableRowSummary, { width: '100%' }]}>
                  <Text style={{ fontWeight: 700, width: '58%' }}>Total</Text>
                  <Text>{currency(data.total_amount, true)}</Text>
                </View>
              </View>
            </View>
          </View>

          <RenderIf condition={!isSpreading}>
            <View style={styles.signatureWrapper} wrap={false}>
              <View style={{ width: '50%' }}>
                <Text>Salesman</Text>
                <View style={styles.signatureBox}>
                  {data.signatures?.salesman?.url ? (
                    <Image
                      style={styles.signatureImage}
                      src={data.signatures.salesman.url}
                    />
                  ) : (
                    false
                  )}
                  <Image />
                </View>
                <Text style={styles.signatureName}>
                  {data.signatures?.salesman?.name || ''}
                </Text>
                <Text>
                  Date:{' '}
                  {data.signatures?.salesman?.created_at
                    ? moment(data.signatures.salesman.created_at).format(
                        'DD MMM YYYY',
                      )
                    : ''}
                </Text>
              </View>
              <View style={{ width: '50%' }}>
                <Text>Customer</Text>
                <View style={styles.signatureBox}>
                  {data.signatures?.customer?.url ? (
                    <Image
                      style={styles.signatureImage}
                      src={data.signatures.customer.url}
                    />
                  ) : (
                    false
                  )}
                </View>
                <Text style={styles.signatureName}>
                  {data.signatures?.customer?.name || ''}
                </Text>
                <Text>
                  Date:{' '}
                  {data.signatures?.customer?.created_at
                    ? moment(data.signatures.customer.created_at).format(
                        'DD MMM YYYY',
                      )
                    : ''}
                </Text>
              </View>
            </View>
          </RenderIf>
        </View>

        <Footer />
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 15,
    fontSize: 10,
    color: '#000',
    fontFamily: 'Roboto',
    paddingBottom: 30,
  },

  container: {
    paddingHorizontal: 20,
  },

  headerSection: {
    flexDirection: 'row',
    fontSize: 8,
    lineHeight: 1.5,
    marginBottom: 20,
  },
  headerSubsection: (isSpreading) => ({
    width: '50%',
    justifyContent: isSpreading ? 'center' : '',
  }),

  contentWrapper: {
    fontSize: 8,
    marginBottom: 40,
  },
  tableHeader: {
    width: '100%',
    flexDirection: 'row',
    color: '#142151',
    fontWeight: 700,
    alignItems: 'center',
    borderBottom: '1px solid black',
    paddingVertical: 10,
  },
  tableRow: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    borderBottom: '1px solid black',
    paddingVertical: 10,
  },
  tableRowSummary: {
    flexDirection: 'row',
    width: '24%',
    paddingVertical: 10,
    alignItems: 'center',
    borderBottom: '1px solid black',
  },

  signatureWrapper: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    fontSize: 8,
  },
  signatureBox: {
    width: 200,
    height: 100,
    border: '1px solid #ccc',
    borderRadius: 6,
    marginVertical: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  signatureName: {
    marginBottom: 3,
    color: '#0070f3',
  },
  signatureImage: {
    width: 160,
    height: 80,
    objectFit: 'contain',
  },
});

export default PdfOrder;
